import { Button, mergeClassName } from '@chain-zen/ui'

import { ANALYTICS_EVENTS } from '../../constants/analytics'
import { useAnalytics } from '../../contexts/analytics-context'

interface LoadboardButtonProps {
  className?: string
  loadsPageURL: string
  totalPosts?: number
  variant?: 'banner' | 'standard'
}

export function LoadboardButton({ loadsPageURL, variant = 'standard', className, totalPosts }: LoadboardButtonProps) {
  const { captureEvent } = useAnalytics()

  const handleClick = () => {
    captureEvent(ANALYTICS_EVENTS.loadboard.modalView)
  }

  const bannerText =
    totalPosts && totalPosts > 0
      ? `${totalPosts} similar load${totalPosts > 1 ? 's' : ''} available.`
      : 'View our available loads.'

  if (variant === 'banner') {
    return (
      <div className={mergeClassName('w-full mt-4', className)}>
        <div className="w-full p-2 bg-yellow-50 dark:bg-yellow-900/30 border border-yellow-200 dark:border-yellow-700 rounded-lg">
          <div className="flex items-center flex-wrap w-full p-2">
            <div className="flex-7">
              <p className="text-sm font-medium text-left p-1">View our available loads.</p>
            </div>
            <div className="flex-5 flex justify-end">
              <Button
                size="sm"
                variant="default"
                className="bg-green-500 hover:bg-green-600 dark:bg-green-600 
                         dark:hover:bg-green-700 text-white"
                onClick={handleClick}
              >
                <a href={loadsPageURL} target="_blank" rel="noopener noreferrer">
                  {bannerText}
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={mergeClassName('w-full mt-4', className)}>
      <Button className="w-full" onClick={handleClick}>
        <a href={loadsPageURL} target="_blank" rel="noopener noreferrer">
          View loadboard
        </a>
      </Button>
    </div>
  )
}
